import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Title } from 'components/typography';
import Image from 'components/image';

import {
  teamMember,
  teamMemberInfo,
  teamMemberName,
  teamMemberPosition,
} from './scss/TeamMemberCard.module.scss';

const TeamMemberCard = ({ name, role, imageSrc, className }) => (
  <div className={classNames(teamMember, className)}>
    <Image src={imageSrc} />
    <div className={teamMemberInfo}>
      <div>
        <Title className={teamMemberName} value={name} />
      </div>
      <div>
        <Title className={teamMemberPosition} size="sm" value={role} />
      </div>
    </div>
  </div>
);

TeamMemberCard.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default TeamMemberCard;
